import React from 'react'
import { connect } from 'react-redux'
import { Interface } from '@leverege/api-redux'
import classnames from 'classnames'
import Pagination from 'react-js-pagination'

import { Dialog, Flex, Button, Toggle, Pane, Label } from '@leverege/ui-elements'
import RelationshipItem from './RelationshipItem'
import style from './style.css'
import { List, Loading, TextInput } from '~/views';

class AddRelationshipModal extends React.Component {

  constructor( props ) {
    super( props )
  
    this.state = {
      pagination : {
        startIndex : 0,
        perPage : 100
      },
      results : {

      },
      search : null,
      force : false
    }
  }

  componentDidMount() {
    this.mounted = true
    this.reload()
  }

  componentWillUnmount() {
    this.mounted = false
  }

  isToOne( att ) {
    return att.relationshipType.endsWith( 'ToOne' )
  }

  isFromOne( att ) {
    return att.relationshipType.startsWith( 'one' )
  }

  reload = () => {
    const { pagination, search, force } = this.state
    const { dispatch, attribute, device, actions } = this.props

    const filter = {
      type : 'logical',
      operator : 'and',
      conditions : [
      ]
    }
    
    if ( this.isFromOne( attribute ) && !force ) {
      filter.conditions.push( {
        type : 'exists',
        not : true,
        field : `data/${attribute.childPath}/id`,
      } )
    } else if ( this.isFromOne( attribute ) && force ) {
      filter.conditions.push( {
        type : 'equals',
        not : true,
        field : `data/${attribute.childPath}/id`,
        value : device.id
      } )
    }

    if ( search ) {
      filter.conditions.push( {
        type : 'groupedText',
        value : search
      } )
    }

    const options = {
      ...pagination
    }

    if ( filter.conditions.length > 0 ) {
      options.filter = filter
    }

    dispatch( actions.list( options ) )
  }

  onPageChange = ( pageNumber ) => {
    this.setState( ( state ) => {
      const startIndex = state.pagination.perPage * ( pageNumber - 1 )
      return { pagination : { ...state.pagination, startIndex } }
    } )
  }

  componentDidUpdate( prevProps, prevState ) {
    const {
      pagination : { startIndex : newStartIndex, perPage : newPerPage },
      search : newSearch,
      force : newForce
    } = this.state
    const {
      pagination : { startIndex : oldStartIndex, perPage : oldPerPage },
      search : oldSearch,
      force : oldForce
    } = prevState

    if (
      oldStartIndex !== newStartIndex ||
      oldPerPage !== newPerPage ||
      newSearch !== oldSearch ||
      oldForce !== newForce
    ) {
      this.reload()
    }
  }

  onSearchChange = ( search ) => {
    this.setState( { search } )
  }

  onCreateNewDevice = () => {
    const { device, attribute, onEvent } = this.props
    if ( onEvent ) {
      onEvent( 'select', { name : `${device.name || device.id}'s ${attribute.path}` } )
    }
  }

  setForce = ( { value } ) => {
    this.setState( { force : value } )
  }

  onEvent = ( type, item ) => {
    const { onEvent } = this.props
    const { force } = this.state
    if ( type === 'select' && item?.id && force ) {
      onEvent( 'select', { id : item?.id, force : true } )
      return
    }
    onEvent( type, item )
  }

  render() {
    const { onHide, show, getList, isLoading } = this.props
    const { pagination, search, results, force } = this.state
    const { startIndex, perPage } = pagination

    const list = getList( pagination )
    let items = null, total = 0
    if ( list && !isLoading ) {
      items = list.items
      total = list.total || 0
    }

    return (
      <Dialog
        variant="dialogLarge"
        title="Select a Device to Add"
        show={show}
        onClose={onHide}
        className={style.dialog}
        footer={(
          <Flex justify="space-between">
            <Pagination
              innerClass={classnames( 'pagination', style.pagination )}
              activePage={( startIndex / perPage ) + 1}
              itemsCountPerPage={perPage}
              totalItemsCount={total}
              pageRangeDisplayed={5}
              onChange={this.onPageChange} />
            <Button onClick={onHide}>Cancel</Button>
          </Flex>
        )}>
        <div className={style.modalBody}>
          <Flex variant="rowM" className={style.searchContainer}>
            <Pane layout="flex:rowM">
              <Toggle variant="secondary" onChange={this.setForce} value={force} />
              <Label>Force Relationship</Label>
            </Pane>
            <Button icon="fa fa-fw fa-refresh" variant="secondary" onClick={this.reload} />
            <TextInput
              className={style.searchBar}
              value={search}
              hint="search" 
              changeOnBlur
              changeOnReturn
              onChange={this.onSearchChange} />
            <i className={classnames( 'fa fa-search', style.searchIcon )} />
          </Flex>
          <List
            className={style.list}
            onEvent={this.onEvent} 
            noItemsView={<div className={style.emptyList}>No Devices Matching Your Search can be Paired</div>}
            items={items}
            itemView={RelationshipItem}
            itemProps={{ showDelete : false }} />
          <button
            type="button"
            className={style.addButton}
            onClick={this.onCreateNewDevice}>
            <i className="fa fa-plus" />
            {' '}
            Create New Device
          </button>
          <Loading show={( isLoading || ( this.interfaceFilter && results[this.interfaceFilter.path] && results[this.interfaceFilter.path].loading ) ) || null} message="Loading..." />
        </div>
      </Dialog>
    )
  }
}

export default connect(
  ( state, props ) => {
    const { device, attribute, getBlueprintIdFromParent } = props

    const actions = Interface.create(
      device.systemId, getBlueprintIdFromParent ?
        attribute.sourceBlueprintId :
        attribute.targetBlueprintId 
    )

    return {
      models : state.models,
      blueprints : state.blueprints,
      getList : pagination => actions.getList( state, pagination ),
      isLoading : actions.isLoading( state ),
      actions
    }
  }
)( AddRelationshipModal )
